const STORAGE_KEY = "izanagi.roadmapLaneHues";

/** ロードマップで担当者ごとに選んだバーの色相 (担当者 ID → 色相)。保存値が無い・壊れている場合は空。 */
export function readStoredRoadmapLaneHues(): Map<string, number> {
	try {
		const parsed: unknown = JSON.parse(window.localStorage.getItem(STORAGE_KEY) ?? "{}");
		if (typeof parsed !== "object" || parsed === null) return new Map();
		return new Map(
			Object.entries(parsed).filter(
				(entry): entry is [string, number] =>
					typeof entry[1] === "number" && entry[1] >= 0 && entry[1] < 360,
			),
		);
	} catch (err: unknown) {
		console.error("ロードマップの色の読み込みに失敗しました", err);
		return new Map();
	}
}

export function writeStoredRoadmapLaneHues(laneHues: ReadonlyMap<string, number>): void {
	try {
		window.localStorage.setItem(STORAGE_KEY, JSON.stringify(Object.fromEntries(laneHues)));
	} catch (err: unknown) {
		// 保存できなくても今の画面の色は変わる。
		console.error("ロードマップの色の保存に失敗しました", err);
	}
}
